module.exports = __webpack_public_path__ + "static/media/earth.34dd956b.png";